"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.refreshBookingByIdExtraReducers = void 0;
const tslib_1 = require("tslib");
const toolkitRaw = tslib_1.__importStar(require("@reduxjs/toolkit"));
const deserializer_1 = tslib_1.__importDefault(require("../../../../utils/deserializer"));
const services_1 = tslib_1.__importDefault(require("../../../../services"));
const Booking_1 = tslib_1.__importDefault(require("../__models__/Booking"));
const getIncludesParams_1 = require("../../../../shared/getIncludesParams");
const refreshBookingById = toolkitRaw.createAsyncThunk('bookings/refresh_booking_by_id', async ({ bookingInternalId: id, options }, { rejectWithValue }) => {
    try {
        const response = await services_1.default.get(`/api/saas/me/bookings/${id}`, {
            params: {
                includes: (0, getIncludesParams_1.getDefaultIncludesParams)('saas_bookings'),
            },
        });
        const payload = (0, deserializer_1.default)(response.data);
        const BookingImplementation = new Booking_1.default(payload);
        if (options === null || options === void 0 ? void 0 : options.onlyMeta) {
            return {
                data: BookingImplementation.data.meta,
                type: 'meta',
            };
        }
        return {
            data: BookingImplementation.data,
            type: 'all',
        };
    }
    catch (eventError) {
        return rejectWithValue(eventError);
    }
});
const refreshBookingByIdExtraReducers = (builder) => {
    builder.addCase(refreshBookingById.fulfilled, (state, action) => {
        var _a;
        if (action.payload.type === 'meta' && ((_a = state.booking.data) === null || _a === void 0 ? void 0 : _a.meta)) {
            state.booking.data.meta = action.payload.data;
        }
        if (action.payload.type === 'all') {
            state.booking.data = action.payload.data;
        }
    });
};
exports.refreshBookingByIdExtraReducers = refreshBookingByIdExtraReducers;
exports.default = refreshBookingById;
//# sourceMappingURL=index.js.map